import { CalendarClock, CheckSquare, Coffee, Mail, MapPin, MessageCircle, Phone, RotateCcw, Users, type LucideIcon } from 'lucide-react';
import type { TipoAtividade } from './tipos';

/** Ajustes do CRM 27/10 (K20): o ícone de cada tipo de tarefa (o `ttIcon` do clone), no cartão do funil e onde mais servir. */
export const ICONE_TIPO_ATIVIDADE: Record<TipoAtividade, LucideIcon> = {
  tarefa: CheckSquare,
  ligacao: Phone,
  reuniao: Users,
  follow_up: RotateCcw,
  email: Mail,
  whatsapp: MessageCircle,
  visita: MapPin,
  almoco: Coffee,
};

export const iconeDoTipo = (tipo: string): LucideIcon => ICONE_TIPO_ATIVIDADE[tipo as TipoAtividade] ?? CalendarClock;
